export default "__VITE_ASSET__DLE2R2c7__"